import { useParams, Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Clock, FileText, ArrowRight } from "lucide-react";

/**
 * TAConfirmationPage — Shown after a TA/HOS assessment is submitted
 */
export default function TAConfirmationPage() {
  const { accessToken } = useParams();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center p-4" data-testid="ta-confirmation-page">
      <Card className="max-w-lg w-full">
        <CardContent className="pt-8 text-center">
          {/* Success icon */}
          <div className="w-16 h-16 bg-[#63C465] rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle2 className="w-8 h-8 text-white" />
          </div>

          <h2 className="text-2xl font-bold text-[#1B3A5C] mb-3" data-testid="ta-confirmation-title">
            Assessment Submitted Successfully
          </h2>

          <p className="text-gray-600 mb-6 leading-relaxed">
            Thank you for completing your Technical Assessment. Your responses have been saved and will be reviewed by our evaluation team.
          </p>

          {/* Info cards */}
          <div className="grid grid-cols-2 gap-3 mb-6 text-left">
            <div className="bg-gray-50 rounded-lg p-3">
              <div className="flex items-center gap-2 mb-1">
                <Clock className="w-4 h-4 text-[#00AEEF]" />
                <span className="text-xs text-gray-500">Next Steps</span>
              </div>
              <p className="text-sm text-[#3b3b3b]">Results will be available within 48 hours</p>
            </div>
            <div className="bg-gray-50 rounded-lg p-3">
              <div className="flex items-center gap-2 mb-1">
                <FileText className="w-4 h-4 text-[#00AEEF]" />
                <span className="text-xs text-gray-500">Reference</span>
              </div>
              <p className="text-sm text-[#3b3b3b]">Your submission has been recorded</p>
            </div>
          </div>

          <p className="text-sm text-gray-500 mb-4">
            If you have questions about the assessment process, contact your HR representative or the assessment support team.
          </p>
        </CardContent>
      </Card>

      <footer className="fixed bottom-0 w-full border-t bg-white py-4 text-center">
        <p className="text-sm text-gray-500">© 2026 THCO</p>
      </footer>
    </div>
  );
}
